import React from 'react';
import styled from 'styled-components';

import { Skeleton } from '@material-ui/lab';

import { icons } from '../../themes/icons';

interface StatCardProps {
  name: string;
  count: number | string;
  compare?: string;
  percentageNumber?: number;
  isNegative?: boolean;
  isDesktop?: boolean;
  icon?: React.ReactNode;
  isFetching?: boolean;
  rightAlignItems?: string;
}

const StatCard: React.FC<StatCardProps> = ({
  name,
  count,
  compare,
  isNegative = false,
  isDesktop = false,
  isFetching = false,
  icon,
  rightAlignItems,
  percentageNumber = 0,
}) => {
  const isNegativePercentage = (percentageNumber || 0) < 0;

  return (
    <StatCardContainer>
      <Left>
        {!isDesktop ? (
          <span className={name === 'Reservations' ? 'reservations' : 'unique'}>
            {name === 'Reservations' ? <icons.ReservationsIcon /> : <icons.UniqueStarIcon />}
          </span>
        ) : (
          <span className={'icon'}>{icon}</span>
        )}
        <Heading>{name}</Heading>
      </Left>
      {isFetching && <Skeleton animation="wave" height={30} width={40} />}
      {!isFetching && (
        <Right alignItems={rightAlignItems}>
          <Count>{count}</Count>
          {compare && <Compare isNegative={isNegativePercentage || isNegative}>{compare}</Compare>}
        </Right>
      )}
    </StatCardContainer>
  );
};

export default StatCard;

const StatCardContainer = styled.div`
  border-bottom: 1px solid #0000000d;
  padding: 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  .reservations {
    background: #c6ede2;
    padding: 8px;
    border-radius: 6px;
    height: 38px;
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .unique {
    background: #f2e3b1;
    padding: 8px;
    border-radius: 6px;
    height: 38px;
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon {
    background: #f5f5f5;
    padding: 8px;
    border-radius: 6px;
    height: 38px;
    width: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Heading = styled.div`
  color: #111111;
  font-size: 13px;
  font-family: Poppins;
  font-weight: 400;
`;

const Right = styled.div<{ alignItems?: string }>`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignItems || 'flex-end'};
  gap: 2px;
`;

const Count = styled.div`
  color: #111111;
  font-size: 15px;
  font-family: Poppins;
  font-weight: 500;
`;

const Compare = styled.div<{ isNegative?: boolean }>`
  color: ${(props) => (props.isNegative ? '#BC3438' : '#408155')};
  font-size: 13px;
  font-family: Poppins;
  font-weight: 400;
`;
